import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CardTypeEnum } from '../../../core/enums/commerce/cards-on-file/card-types';

@Component({
    selector: 'app-card-type-icon',
    templateUrl: './card-type-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class CardTypeIconComponent {
    @Input() cardType: string | undefined;

    cardTypeEnum = CardTypeEnum;
}
